document.addEventListener("DOMContentLoaded", function() {
  const items = Array.from(document.querySelectorAll("#all-blogposts .blogpost-item"));
  // Shuffle
  items.sort(() => 0.5 - Math.random());
  // Take 3
  const selected = items.slice(0, 3);
  const container = document.getElementById("random-blogposts");
  selected.forEach(item => {
    container.appendChild(item.cloneNode(true));
  });
});